import React, { Fragment } from 'react';

import { AITopicsByPerson } from '../../../../../ai-topics/ai-topics-by-person';
import { messages } from '../../../../../messages';
import { useAIAnswerContext } from '../../../../ai-answer-context';
import type { NLPSearchWhoResultType } from '../../../../types';
import { getTypedJSONResultDataAssistanceService } from '../../../../utils/getTypedJSONResultData';
import { RecentWorkList } from '../recent-work-list/recent-work-list';
import { ProfileSection } from '../user-profile-section/profile-section';
import { AIAnswerWhoSection } from './who-result-section';

export const AIAnswerWhoResult = (): React.JSX.Element => {
	const { commonAttributes, isAdminHubAIEnabled } = useAIAnswerContext();
	const { answerString, cloudId, sessionId } = commonAttributes;

	// answerString should have at least one result or else <AIAnswerError /> will be rendered
	const whoResult: NLPSearchWhoResultType = {
		user_metadata: getTypedJSONResultDataAssistanceService(answerString).parsedResult,
	} as NLPSearchWhoResultType;

	const userResults = whoResult.user_metadata;
	// BE will always return first object as the primary user result
	const primaryUser = userResults[0];

	return (
		<Fragment>
			<ProfileSection
				accountId={primaryUser.account_id}
				name={primaryUser.name}
				email={primaryUser.email}
				avatarUrl={primaryUser.avatar_url}
				profileUrl={primaryUser.profile_url}
				jobTitle={primaryUser.job_title}
				department={primaryUser.department}
				location={primaryUser.location}
				time={primaryUser.time}
			/>
			{isAdminHubAIEnabled ? (
				<AITopicsByPerson
					cloudId={cloudId}
					userId={primaryUser.account_id ?? ''}
					userName={primaryUser.name}
					sessionId={sessionId}
				/>
			) : (
				<AIAnswerWhoSection
					sectionId="frequent_locations"
					sectionHeader={messages.ai_answer_who_questions_frequent_locations_header}
					sectionResults={primaryUser.containers}
					avatarAppearance="square"
				/>
			)}
			<AIAnswerWhoSection
				sectionId="frequent_collaborators"
				sectionHeader={messages.ai_answer_who_questions_frequent_collaborators_header}
				sectionResults={primaryUser.collaborators?.slice(0, 3)}
				avatarAppearance="circle"
			/>
			<AIAnswerWhoSection
				sectionId="teams"
				sectionHeader={messages.ai_answer_who_questions_teams_header}
				sectionResults={primaryUser.teams}
				avatarAppearance="square"
			/>
			{primaryUser.recentActivity && (
				<RecentWorkList
					name={primaryUser.name}
					activities={primaryUser.recentActivity}
					viewAllUrl={primaryUser.viewAllLink}
				/>
			)}
		</Fragment>
	);
};
